<template>
 <transition appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
 <q-layout id="main" view="lhr Lpr lfr">
    <m-header colorType="white" isHome/>
    <div id="content-1">
      <div class="row shadow-10 fixed-height">
        <div class="col-lg-6 offset-lg-6 col-md-6 col-12 content">
          <h1 id="title-main">SITE EM MANUTENÇÃO</h1>
        </div>
      </div>
      <div style="background-color: black;padding:1px"></div>    
    </div>
 </q-layout>
 </transition>
</template>

<script>
import MHeader from '@/components/Header'
import MFooter from '@/components/Footer'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import Social from '@/components/Social'

export default {
  components: {
    MHeader,
    MFooter,
    Social,
    Carousel3d,
    Slide
  },
  data () {
    return {
      email: ''
    }
  },
  created () {
    let behavior = 'smooth'
    let el = document.getElementById('content-1')
    el.scrollIntoView({
      block: 'start',
      behavior
    })
  },
  methods: {
    goToAnchor (id) {
      let behavior = 'smooth'
      let el = document.getElementById(id)
      el.scrollIntoView({
        block: 'start',
        behavior
      })
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'Montserrat';
  src: url('../assets/fonts/Montserrat-Regular.ttf');
}
#main{
  overflow: hidden;
}
.fixed-height{
  height: 100vh;
  background: linear-gradient(298deg,rgba(0,0,0,0.8) 20%,rgba(0,0,0,0.5) 52%,transparent 80%,transparent 113%),url('../assets/bg-home.jpg');
  background-size: cover; /*Css padrão*/
}
h1{
  font-size: 250%;
  margin-top:0;
}
h3{
  font-size: 140%;
  line-height: 1.2;
}
h2{
  font-size: 190%;
  font-family: 'Montserrat', sans-serif;
}
.content{
  padding-top: 25vh;
  padding-bottom: 8rem;
  text-align: right;
  color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 3%;
  padding-right: 3%;
}
.heigth{
  height: 40vh;
}
.shipping{
  background-color: #326394;
  color: white;
  transition: transform .3s;
  cursor: pointer;
}
.shipping:hover{
  transform: scale(1.03);
}
.offer{
  background-color: rgba(98, 184, 148);
  color: white;
  transition: transform .3s;
  cursor: pointer;
}
.offer:hover{
  transform: scale(1.03);
}
.freights{
  background-color: #ff8100;
  color: white;
  transition: transform .3s;
  cursor: pointer;
}
.freights:hover{
  transform: scale(1.03);
}
.flex-col{
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.padding{
  padding: 2rem 2rem;
}
.font-w4{
  font-weight: 400;
}
.font-w6{
  font-weight: 600;
}
#title-main{
  font-size: 9vh;
  font-weight: 600;
  margin-bottom:0;
  margin-top: 0;
}
#content-2{
  padding: 3rem 0;
  color: #111111;
}
#content-3{
  background-color: white;
  color: #111111;
  padding-top: 2rem;
  padding-bottom: 8rem;
}
#content-4{
  padding-top: 1rem;
  padding-bottom: 2rem;
  color: white;
  background: linear-gradient(-308deg, #878484 -50%, #111111 70%);
}
#content-5{
  padding-top: 1rem;
  padding-bottom: 2rem;
}
.orange-logo{
  color: #F79520;
}
.blue-logo{
  color: #326394;
}
.logo {
  font-family: 'Nunito', sans-serif !important;
  font-size: 3rem;
  padding-left: 3%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.bg-img{
  margin-top:10%;
  margin-bottom: 4%;
  padding: 3%;
  transition: transform .3s;
}
.bg-img:hover{
  transform: scale(1.08);
}
.numbers {
  font-size: 500%; margin-top:0; color: orange;
  margin-bottom: 0.5rem;
}
.input{
  width: 100%;
  margin-right: 5px;
}
@media only screen and (max-width: 640px) {
 .fixed-height{
  height: 100vh;
  background: linear-gradient(-308deg, #878484 -50%, #111111 70%);
  background-size: cover; /*Css padrão*/
}
.content{
  padding-top: 11rem;
  padding-bottom: 8rem;
  text-align: right;
  color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 3%;
  padding-right: 3%;
}
#title-main{
  font-size: 180%;
  font-weight: 600;
  margin-bottom:0;
  margin-top: 0;
  text-align: center;
}
.new-text-center{
  text-align: center;
}
.input{
  width: 60%;
  margin-right: 5px;
}
}
</style>
